import { useEffect } from 'react';
import { usePushdownContext } from '../providers/Pushdown/PushdownProvider';
import { useSessionStorageStatus } from '../providers/SessionStorageStatus/SessionStorageStatusProvider';

export default function useSessionStorageCheck() {
    const { status } = useSessionStorageStatus();
    const { showPushdown } = usePushdownContext();

    useEffect(() => {
        if (status === 'unusable') {
            showPushdown('blockedSessionStorage');
        }
    }, [status]);
}
